import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_BEGIN,
  MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_SUCCESS,
  MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_FAILURE,
  MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function checkEditSubsLock(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/checkEditSubLock`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCheckEditSubsLockError() {
  return {
    type: MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_DISMISS_ERROR,
  };
}

export function useCheckEditSubsLock() {
  const dispatch = useDispatch();

  const { checkEditSubsLockPending, checkEditSubsLockError } = useSelector(
    state => ({
      checkEditSubsLockPending: state.manageSubs.checkEditSubsLockPending,
      checkEditSubsLockError: state.manageSubs.checkEditSubsLockError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(checkEditSubsLock(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCheckEditSubsLockError());
  }, [dispatch]);

  return {
    checkEditSubsLock: boundAction,
    checkEditSubsLockPending,
    checkEditSubsLockError,
    dismissCheckEditSubsLockError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        checkEditSubsLockPending: true,
        checkEditSubsLockError: null,
      };

    case MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        checkEditSubsLockPending: false,
        checkEditSubsLockError: null,
      };

    case MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        checkEditSubsLockPending: false,
        checkEditSubsLockError: action.data.error,
      };

    case MANAGE_SUBS_CHECK_EDIT_SUBS_LOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        checkEditSubsLockError: null,
      };

    default:
      return state;
  }
}
